import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import BrandMark from "@/components/common/BrandMark";
import { useI18n } from "@/i18n";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email }, { _skipAuthRedirect: true });
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6 dark:bg-slate-950">
      <div className="w-full max-w-sm rounded-xl border bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <BrandMark className="mb-6 h-10 w-10" />
        <h1 className="font-heading text-2xl font-bold">{t("auth.forgot_title")}</h1>
        <p className="mt-2 text-sm text-slate-500">{sent ? t("auth.forgot_sent") : t("auth.forgot_hint")}</p>
        {!sent && (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="reset-email">{t("auth.email")}</Label>
              <Input id="reset-email" type="email" autoComplete="email" required value={email}
                onChange={(event) => setEmail(event.target.value)} data-testid="forgot-email-input" />
            </div>
            <Button type="submit" className="w-full" disabled={busy} data-testid="forgot-submit">
              {t("auth.send_reset_link")}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-5 block text-center text-sm text-primary hover:underline">
          {t("auth.back_to_login")}
        </Link>
      </div>
    </div>
  );
}
